import { IThreeContextData } from '@src/services/ThreeContext';
import React from 'react';
import * as THREE from 'three';
import { OrbitControls } from 'three/examples/jsm/Addons.js';
import Stats from 'three/examples/jsm/libs/stats.module.js';
import ThreePresentation from '../../ThreePresentation/ThreePresentation';
import { WorldGenerator } from './services/WorldGenerator';
import GUI from 'three/examples/jsm/libs/lil-gui.module.min.js';
import { ViewportGizmo } from "three-viewport-gizmo";
import SkyController from './services/SkyController';
import RenderController from './services/RenderController';
import TerrainController from './services/TerrainController';

const TerrainScene: React.FC = () => {

    const onStart = React.useCallback(
        (context: IThreeContextData) => {

            const props = {
                seed: 123456,
                time: 0.1,
            };

            const worldSize: number = 512;
            const worldHalfSize = worldSize / 2;

            const raycaster = new THREE.Raycaster();
            const pointer = new THREE.Vector2();

            const { renderer, scene, camera, canvas, container } = context;

            renderer.setClearColor(0x004488, 1);
            renderer.shadowMap.enabled = true;
            renderer.shadowMap.type = THREE.PCFSoftShadowMap;
            renderer.shadowMap.autoUpdate = true;

            // Stats
            const stats = new Stats();
            stats.dom.style.position = "absolute";
            container.appendChild(stats.dom);

            // GUI
            const gui = new GUI();
            gui.add(props, "seed", 1, 1000000, 1);
            gui.add(props, "time", 0, 1, 0.001);
            container.appendChild(gui.domElement);

            // camera
            camera.position.set(1, 1, 1);
            camera.rotateY(Math.PI / 4);
            camera.rotateX(-Math.PI / 5);

            const controls = new OrbitControls(camera, canvas);
            controls.enableRotate = true;
            controls.enableZoom = true;
            controls.enablePan = true;
            controls.minDistance = 100;
            controls.maxDistance = 25000;
            controls.maxPolarAngle = Math.PI / 2;

            controls.target.y = 0;
            camera.position.y = controls.target.y + 2000;
            camera.position.x = 2000;
            camera.far = 100000;
            camera.updateProjectionMatrix();
            controls.update();

            /*const geometryHelper = new THREE.ConeGeometry(20, 100, 3);
            geometryHelper.translate(0, 50, 0);
            geometryHelper.rotateX(Math.PI / 2);

            const helper = new THREE.Mesh(geometryHelper, new THREE.MeshNormalMaterial());
            scene.add(helper);

            const onPointerMove = (event: MouseEvent) => {
                pointer.x = (event.clientX / renderer.domElement.clientWidth) * 2 - 1;
                pointer.y = - (event.clientY / renderer.domElement.clientHeight) * 2 + 1;
                raycaster.setFromCamera(pointer, camera);

                // See if the ray from the camera into the world hits one of our meshes
                const intersects = raycaster.intersectObject(terrain);

                // Toggle rotation bool for meshes that we clicked
                if (intersects.length > 0) {
                    const face = intersects[0].face;

                    if (!!face) {
                        helper.position.set(0, 0, 0);
                        helper.lookAt(face.normal);
                        helper.position.copy(intersects[0].point);
                    }
                }
            }

            container.addEventListener("pointermove", onPointerMove);*/

            const gizmo = new ViewportGizmo(camera, renderer);
            gizmo.attachControls(controls);

            const skyController = new SkyController(scene);
            const renderController = new RenderController(scene);

            const worldGenerator = new WorldGenerator(props.seed, {
                waterLevel: 0.1,
                snowLevel: 0.2,
                water: {
                    color: 0x2389da,
                    opacity: 1,
                    waveSpeed: 0.0008,
                    waveScale: 0.018,
                    lodThreshold: 3,
                },
            });

            const terrainController = new TerrainController(scene, worldGenerator);

            return {
                props,
                stats,
                gui,
                controls,
                gizmo,
                skyController,
                renderController,
                terrainController,
            };
        },
        []
    );

    const onUpdate = React.useCallback(
        (context: IThreeContextData, state: ReturnType<typeof onStart>) => {
            state.controls.target.setY(0);
            state.controls.update();
            state.stats.update();

            state.skyController.update(state.props.time);
            state.renderController.update(context.deltaTime);
            state.terrainController.update(state.controls.target, context.camera.position, context.deltaTime);

            state.gizmo.render();
        },
        []
    );

    return (
        <div>
            <ThreePresentation
                onStart={onStart}
                onUpdate={onUpdate}
            />
        </div>
    )
};

export default TerrainScene;

